/**
 * ATTENTION! This file is auto-generated for the 'catalog' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import type { ProductCatalogRepository } from '../server/repositories/ProductCatalogRepository';
import type { ProductRepository } from '../server/repositories/ProductRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","meta","getInstance","columns","filters"];

type ProductCatalogRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ProductCatalogRepository>;
export function useProductCatalogRepository(): ProductCatalogRepositoryClient { return makeRepositoryProxy<ProductCatalogRepositoryClient>('catalog::ProductCatalogRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useProductCatalogRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const productCatalogRepository = useProductCatalogRepository();

type ProductRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ProductRepository>;
export function useProductRepository(): ProductRepositoryClient { return makeRepositoryProxy<ProductRepositoryClient>('catalog::ProductRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useProductRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const productRepository = useProductRepository();
